


















































import {Component, Prop, Vue} from "vue-property-decorator";
import {categories} from "@/entity/CategoryEntity";

@Component({})
export default class OrderTotals extends Vue {
    @Prop({required:true,default:{}}) data!:any;
    @Prop({required:true,default:false}) dateChanged!:boolean;
    date: String = (new Date()).toISOString();


}
